__turbopack_context__.v({
  "banner": "rmEiXq_banner",
  "banner--hidden": "rmEiXq_banner--hidden",
  "shimmer": "rmEiXq_shimmer",
  "text-bar-sweep": "rmEiXq_text-bar-sweep",
});
